import { render, staticRenderFns } from "./UpdateHandler.vue?vue&type=template&id=31d77721&scoped=true"
import script from "./UpdateHandler.vue?vue&type=script&lang=js"
export * from "./UpdateHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d77721",
  null
  
)

export default component.exports